import {
  WebsiteContainer,
  WebsiteEyebrow,
  WebsiteHeading,
  WebsiteSection,
  WebsiteText,
} from "@-/dev.improve.haniverse.components.website";

const LANDING_FAQ_ITEMS = [
  {
    answer:
      "Yes, to start. The free tier includes every lesson up to roughly HSK 1, reviews for everything you add, and the full character reference. Premium unlocks the lessons beyond that.",
    question: "Is Haniverse free?",
  },
  {
    answer:
      "Yes. Level 1 starts with single strokes, and your first pinyin lesson starts with one sound and one tone. No lesson expects anything an earlier lesson didn’t teach you.",
    question: "I’m a complete beginner. Is Haniverse for me?",
  },
  {
    answer:
      "No. A story is there to make a character stick while it’s new, and once you know the character you won’t need it. If a different picture works better for you, every character has room for your own notes.",
    question: "Do I have to memorize the stories?",
  },
  {
    answer:
      "Both. Pick simplified or traditional characters, switch any time, and see how the two forms relate.",
    question: "Simplified or traditional?",
  },
  {
    answer:
      "Haniverse schedules meaning, pronunciation and word reviews separately with FSRS, a modern spaced-repetition algorithm. Knowing what a character means never hides that you’ve forgotten how to say it.",
    question: "What makes the reviews different?",
  },
  {
    answer:
      "Yes. Sign in on any iPhone or Android phone and your cards and review history come with you.",
    question: "Does my progress sync between devices?",
  },
];

export function LandingFaqSection() {
  return (
    <WebsiteSection id="questions">
      <WebsiteContainer className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
        <div>
          <WebsiteEyebrow tone="muted">Questions</WebsiteEyebrow>
          <WebsiteHeading className="mt-4 max-w-[12ch]" level={2}>
            Good to know before you download.
          </WebsiteHeading>
        </div>

        <div className="border-t border-black/12">
          {LANDING_FAQ_ITEMS.map((item, index) => (
            <details
              className="group border-b border-black/12 py-5 sm:py-6"
              key={item.question}
              open={index === 0}
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 text-lg font-semibold tracking-[-0.02em] after:text-2xl after:font-normal after:text-website-accent after:transition-transform after:content-['+'] group-open:after:rotate-45 sm:text-xl [&::-webkit-details-marker]:hidden">
                {item.question}
              </summary>
              <WebsiteText className="mt-3 max-w-[42rem]">{item.answer}</WebsiteText>
            </details>
          ))}
        </div>
      </WebsiteContainer>
    </WebsiteSection>
  );
}
